import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { VerifySmsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { VerifySmsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const verifySms = (request: VerifySmsRequest, options?: CashRequestOptions) =>
  post<VerifySmsRequest, VerifySmsResponse>('/2.0/cash/verify-sms', request, { ...options, rejectOnError: true })
